(function () {
  'use strict';

  function initIntro(section) {
    if (section.dataset.pureMobileIntroReady === 'true') return;

    var intro = section.querySelector('[data-pure-mobile-price]');
    var source = section.querySelector('[data-price-wrapper]');
    if (!intro || !source) return;

    function syncPrice() {
      var current = source.querySelector('[data-product-price]');
      var compare = source.querySelector('[data-compare-price]');
      var mobileCurrent = intro.querySelector('[data-pure-mobile-current-price]');
      var mobileCompare = intro.querySelector('[data-pure-mobile-compare-price]');

      if (current && mobileCurrent) {
        mobileCurrent.textContent = current.textContent.trim();
      }

      if (compare && mobileCompare) {
        mobileCompare.textContent = compare.textContent.trim();
        mobileCompare.hidden =
          compare.classList.contains('hide') || !mobileCompare.textContent;
      }
    }

    if (window.MutationObserver) {
      new MutationObserver(syncPrice).observe(source, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    syncPrice();
    section.dataset.pureMobileIntroReady = 'true';
  }

  function initBar(bar) {
    if (bar.dataset.pureMobileReady === 'true') return;

    var section = bar.closest('[data-section-type="product"]');
    var form = document.getElementById(bar.dataset.productFormId);
    var originalId = bar.dataset.originalButtonId;
    var original = document.getElementById(originalId);
    var add = bar.querySelector('[data-pure-mobile-add]');
    var value = bar.querySelector('[data-pure-mobile-quantity-value]');

    if (!section || !form || !original || !add || !value) return;

    var quantity = Array.prototype.find.call(form.elements, function (field) {
      return field.name === 'quantity';
    });

    if (!quantity) {
      quantity = document.createElement('input');
      quantity.type = 'hidden';
      quantity.name = 'quantity';
      quantity.value = '1';
      form.appendChild(quantity);
    }

    function validQuantity(input) {
      var parsed = parseInt(input, 10);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
    }

    function syncQuantity() {
      value.textContent = String(validQuantity(quantity.value));
    }

    function setQuantity(next) {
      var maximum = parseInt(quantity.max, 10);
      next = Math.max(1, next);

      if (Number.isFinite(maximum) && maximum > 0) {
        next = Math.min(next, maximum);
      }

      quantity.value = String(next);
      quantity.dispatchEvent(new Event('input', { bubbles: true }));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
      syncQuantity();
    }

    function syncButton() {
      original = document.getElementById(originalId);
      add.disabled = !original || original.disabled;

      if (original) {
        var label = original.querySelector('[data-add-to-cart-text]');
        if (label && label.textContent.trim()) {
          add.textContent = label.textContent.trim();
        }
      }
    }

    function syncScrollPosition() {
      original = document.getElementById(originalId);
      if (!original) return;

      var triggerY = window.innerHeight - bar.offsetHeight;
      var originalTop = original.getBoundingClientRect().top;

      bar.classList.toggle('is-past-original', originalTop <= triggerY);
    }

    bar.addEventListener('click', function (event) {
      var adjustment = event.target.closest('[data-pure-mobile-quantity]');

      if (adjustment) {
        setQuantity(
          validQuantity(quantity.value) +
          (adjustment.dataset.pureMobileQuantity === 'plus' ? 1 : -1)
        );
        return;
      }

      if (event.target.closest('[data-pure-mobile-add]')) {
        syncButton();

        if (original && !original.disabled) {
          setQuantity(validQuantity(quantity.value));
          original.click();
        }
      }
    });

    quantity.addEventListener('input', syncQuantity);
    quantity.addEventListener('change', syncQuantity);

    var formContainer = original.closest('[id^="AddToCartForm--"]');

    if (formContainer && window.MutationObserver) {
      new MutationObserver(syncButton).observe(formContainer, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    syncQuantity();
    syncButton();

    bar.dataset.pureMobileReady = 'true';
    bar.hidden = false;
    section.classList.add('pure-mobile-product-bar-active');

    window.addEventListener('scroll', syncScrollPosition, { passive: true });
    window.addEventListener('resize', syncScrollPosition);
    syncScrollPosition();
  }

  function init() {
    document
      .querySelectorAll('[data-section-type="product"]')
      .forEach(initIntro);

    document
      .querySelectorAll('[data-pure-mobile-product-bar]')
      .forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
}());